import {useGetTokenByCode} from "hooks/Auth";
import {useQueryParams} from "hooks/useQueryParams";
import {useEffect} from "react";
import {Spinner} from "react-bootstrap";
import CONFIG from "config/env";
import axiosInstance from "services/axios";
import {setAuthenticatedUser} from "store/actions/auth";
import {setSelectedHospital} from "store/actions/hospital";
import {useDispatch} from "react-redux";
import {useHistory} from "react-router-dom";

export function SSOHandler() {
	const SUPPORTED_ROLE_IDS = [1, 2, 3, 4, 5, 6, 7, 8];
	const dispatch = useDispatch();
	const query = useQueryParams();
	const code = query.get("code");
	const {mutate} = useGetTokenByCode();
	const history = useHistory();

	useEffect(() => {
		if (!code) return;

		const bootstrapSession = () => {
			axiosInstance
				.get("/auth/me")
				.then(res => {
					const basicProfile = res.data.data;
					const rsMany = Array.isArray(basicProfile?.staff?.rsMany) ? basicProfile.staff.rsMany : [];
					const getAllRolesId = rsMany.map(item => item?.roleId).filter(Boolean);
					const selectedRoleId =
						getAllRolesId.find(roleId => SUPPORTED_ROLE_IDS.includes(Number(roleId))) || 0;
					const selectedHospital =
						rsMany.find(item => Number(item?.roleId) === Number(selectedRoleId)) || null;
					const data = {
						accessToken: "",
						accessExpired: null,
						isPersisted: true,
						profile: basicProfile,
						isLoggedIn: true,
						userRoles: [...new Set(getAllRolesId)],
						roleId: selectedRoleId,
					};

					dispatch(setAuthenticatedUser(data));
					dispatch(setSelectedHospital(selectedHospital));
					history.replace("/");
				})
				.catch(() => {
					window.location.href = `${CONFIG.sso.SSO_ENDPOINT || "/auth/login"}`;
				});
		};

		mutate(
			{
				code: code,
			},
			{
				onSuccess() {
					bootstrapSession();
				},
				onError() {
					// Cookie-based SSO fallback: some envs already set cookie during redirect.
					bootstrapSession();
				},
			},
		);
	}, [code]);

	if (!code) {
		return (
			<div className="d-flex w-100 justify-content-center align-items-center" style={{minHeight: "100vh"}}>
				Code required!
			</div>
		);
	}

	return (
		<div className="d-flex w-100 justify-content-center align-items-center" style={{minHeight: "100vh"}}>
			<Spinner />
		</div>
	);
}
